import { defineMessages } from 'react-intl';

export default defineMessages({
  notesSnackbarMsg: {
    id: 'CourseDetailsNotes.notesSnackbarMsg',
    defaultMessage: 'Course notes have been updated',
    description:
      'Success message displayed in courses details notes when notes updated',
  },
  submitBtnLabel: {
    id: 'General.submitBtnLabel',
    defaultMessage: 'Submit',
    description: ' Submit button title',
  },
  refuseDeleteBtnLabel: {
    id: 'General.refuseDeleteBtnLabel',
    defaultMessage: 'Oops! no thanks',
    description: 'Refuse delete title',
  },
  deleteBtnLabel: {
    id: 'General.deleteBtnLabel',
    defaultMessage: 'Delete',
    description: 'Delete button title',
  },
  noteWillBeRemovedMsg: {
    id: 'CourseDetailsNotes.noteWillBeRemovedMsg',
    defaultMessage: 'Note <b>{text}</b> will be removed from the course.',
    description:
      'Message displayed in courses details notes before remove note from the course',
  },
  wantToDeleteTitle: {
    id: 'CourseDetailsNotes.wantToDeleteTitle',
    defaultMessage: 'Are you sure you want to delete this note?',
    description:
      'Confirm dialog title displayed in courses notes to submit remove',
  },
  videoNotesLabel: {
    id: 'CourseDetailsNotes.videoNotesLabel',
    defaultMessage: 'Video notes',
    description: 'Notes sub-header label displayed in courses notes',
  },
  textNotesLabel: {
    id: 'CourseDetailsNotes.textNotesLabel',
    defaultMessage: 'Text notes',
    description: 'Notes sub-header label displayed in courses notes',
  },
  shareNotesDialogTitle: {
    id: 'CourseDetailsNotes.shareNotesDialogTitle',
    defaultMessage: 'Share course notes for:',
    description: 'Dialog title displayed in courses notes',
  },
  removeTooltipTitle: {
    id: 'CourseDetailsNotes.removeTooltipTitle',
    defaultMessage: 'Remove',
    description: 'Remove tooltip title displayed in courses notes',
  },
  notesOptionsNoneLabel: {
    id: 'CourseDetailsNotes.notesOptionsNoneLabel',
    defaultMessage: 'None',
    description: 'Note option label displayed in courses notes',
  },
  notesOptionsNoneDescription: {
    id: 'CourseDetailsNotes.notesOptionsNoneDescription',
    defaultMessage: 'Only you can watch the course notes',
    description: 'Note option description displayed in courses notes',
  },
  notesOptionsTeachersAndGroupLeaderLabel: {
    id: 'CourseDetailsNotes.notesOptionsTeachersAndGroupLeaderLabel',
    defaultMessage: 'Teachers and Group leader',
    description:
      'Note option "Teachers and Group leader" label displayed in courses notes',
  },
  notesOptionsTeachersAndGroupLeaderLabelProfessional: {
    id:
      'CourseDetailsNotes.notesOptionsTeachersAndGroupLeaderLabelProfessional',
    defaultMessage: 'Teachers and Group leader',
    description:
      'Note option "Teachers and Group leader" label displayed in courses notes',
  },
  notesOptionsTeachersDescription: {
    id: 'CourseDetailsNotes.notesOptionsTeachersDescription',
    defaultMessage:
      'Teachers in your group can watch the course notes on your public profile',
    description: 'Note option description displayed in courses notes',
  },
  notesOptionsTeachersDescriptionProfessional: {
    id: 'CourseDetailsNotes.notesOptionsTeachersDescriptionProfessional',
    defaultMessage:
      'Teachers in your group can watch the course notes on your public profile',
    description:
      'Note option description displayed in courses notes for professional organizations',
  },
  notesOptionsGroupLabel: {
    id: 'CourseDetailsNotes.notesOptionsGroupLabel',
    defaultMessage: 'Group',
    description: 'Note option label displayed in courses notes',
  },
  notesOptionsGroupDescription: {
    id: 'CourseDetailsNotes.notesOptionsGroupDescription',
    defaultMessage:
      'All group users can watch the course notes on your public profile',
    description: 'Note option description displayed in courses notes',
  },
  shareLabel: {
    id: 'CourseDetailsNotes.share',
    defaultMessage: 'Share',
    description: 'The text displayed in share button',
  },
  sharedForGroupLabel: {
    id: 'CourseDetailsNotes.sharedForGroupLabel',
    defaultMessage: 'Shared for group',
    description: 'The "Shared for group" label in share button',
  },
  sharedForTeachersLabel: {
    id: 'CourseDetailsNotes.sharedForTeachersLabel',
    defaultMessage: 'Shared for teachers',
    description: 'The "Shared for teachers" label in share button',
  },
});
